if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form) return;

        this.realSubmit = this.form.querySelector('[type="submit"]');
        this.button = this.querySelector('[data-sticky-submit]');
        this.label = this.querySelector('[data-sticky-label]');
        this.price = this.querySelector('[data-sticky-price]');
        this.productInfo = this.form.closest('product-info') || this.form.closest('section');

        this.removeAttribute('hidden');
        this.button.addEventListener('click', this.onClick.bind(this));

        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              this.removeAttribute('data-visible');
            } else if (entry.boundingClientRect.top < 0) {
              this.setAttribute('data-visible', '');
            }
          },
          { threshold: 0 }
        );
        this.observer.observe(this.form);

        // Mirror price + availability whenever Dawn re-renders the buy box
        // (variant changes swap DOM inside product-info).
        this.mirror = this.mirrorFromForm.bind(this);
        this.mutationObserver = new MutationObserver(this.mirror);
        if (this.productInfo) {
          this.mutationObserver.observe(this.productInfo, { childList: true, subtree: true });
        }
        this.mirrorFromForm();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mutationObserver) this.mutationObserver.disconnect();
      }

      mirrorFromForm() {
        if (!this.productInfo) return;
        const priceEl = this.productInfo.querySelector('.price__regular .price-item--regular, .price__sale .price-item--sale');
        if (priceEl && this.price) this.price.textContent = priceEl.textContent.trim();
        if (this.realSubmit && this.label) {
          const realLabel = this.realSubmit.querySelector('span');
          if (realLabel) this.label.textContent = realLabel.textContent.trim();
          this.button.toggleAttribute('disabled', this.realSubmit.hasAttribute('disabled'));
        }
      }

      onClick() {
        if (!this.realSubmit || this.realSubmit.hasAttribute('disabled')) return;
        this.realSubmit.click();
      }
    }
  );
}
